export default __webpack_public_path__ + "static/media/sendmsg.9c0303d4.svg";